import { useSiteModelContext } from 'features/siteMap/contexts/SiteModelContext'
import { MapInteractionAPIs } from 'features/siteMap/SiteViewMap'
import { TilesetMapFeatureDispatch } from 'features/siteMap/tilesetMap/features/TilesetMapFeatureDispatch'
import { useOverlaysControls } from 'features/siteMap/tilesetMap/OverlaysHandler'
import {
  ExtraLabelDisplayFn,
  UnitDisplayPropertiesFn,
} from 'features/siteMapViz'
import isNil from 'lodash/isNil'
import React, { ReactNode } from 'react'
import { GeckoGeographicPin } from 'types'

import { GeographicPins } from './GeographicPins'

const PRIMITIVE_KINDS = new Set(['box', 'sphere', 'cylinder'])

interface TilesetMapFeaturesProps {
  shouldDisplayTaggedUnit: NonNullable<
    MapInteractionAPIs['shouldDisplayTaggedUnit']
  >
  getUnitDisplayName: (unitID: string) => string | undefined
  showUntaggedModels: boolean
  getUnitDisplayProperties: UnitDisplayPropertiesFn
  getExtraLabelDisplay: ExtraLabelDisplayFn
  pins: readonly GeckoGeographicPin[]
}
export const TilesetMapFeatures: React.FC<TilesetMapFeaturesProps> = (
  props
) => {
  const { siteModel } = useSiteModelContext()
  const { showPrimitives } = useOverlaysControls()

  const {
    showUntaggedModels,
    shouldDisplayTaggedUnit,
    getUnitDisplayProperties,
    getUnitDisplayName,
  } = props
  const features = React.useMemo(() => {
    const featureComponents = new Array<ReactNode>()
    for (const key in siteModel.data.features) {
      const feature = siteModel.data.features[key]
      feature.id = key

      const isPrimitive = PRIMITIVE_KINDS.has(feature.kind)

      const baseVisible = !feature.unit_id
        ? showUntaggedModels
        : (shouldDisplayTaggedUnit(feature.unit_id) ?? showUntaggedModels)

      const visible = isPrimitive ? baseVisible && showPrimitives : baseVisible

      featureComponents.push(
        <TilesetMapFeatureDispatch
          key={key}
          feature={feature}
          featureDisplayName={
            isNil(feature.unit_id)
              ? undefined
              : getUnitDisplayName(feature.unit_id)
          }
          visible={visible}
          getUnitDisplayProperties={getUnitDisplayProperties}
          getExtraLabelDisplay={props.getExtraLabelDisplay}
        />
      )
    }
    return featureComponents
  }, [
    siteModel,
    showUntaggedModels,
    showPrimitives,
    shouldDisplayTaggedUnit,
    getUnitDisplayProperties,
    props.getExtraLabelDisplay,
    getUnitDisplayName,
  ])

  return (
    <group>
      {features.map((f) => f)}
      <GeographicPins pins={props.pins} />
    </group>
  )
}
